import PropTypes from "prop-types";
import React from "react";
import { get } from "lodash";
import UploadButton from "components/Atoms/UploadButton";
import File from "components/Global/Editors/FileUploadEditor/View/FormFileUpload/File";
import FileFactory from "components/Global/Editors/FileUploadEditor/Factory";
import CSSModules from "react-css-modules";
import css from "./styles.scss";
import { noop } from "utils/General";

const FileUploadView = CSSModules(
  ({
    deleteFile,
    showFilepicker,
    files,
    disabled,
    allowDownload,
    placeholder,
    column,
    loadingUpload
  }) => (
    <div>
      <div styleName="wrapper">
        {!disabled ? (
          <div styleName="attach">
            <UploadButton onClick={!loadingUpload ? showFilepicker : noop} />
          </div>
        ) : (
          ""
        )}
        {!files.length && !loadingUpload && (
          <div styleName="empty">
            {get(column, ["settings", "placeholder"]) || placeholder}
          </div>
        )}

        {loadingUpload && <div className={css.loading}>Uploading...</div>}
        {!loadingUpload &&
          files.map(file => (
            <File
              key={file.id}
              id={file.id}
              allowDownload={allowDownload}
              mimetype={file.mimetype}
              disabled={disabled}
              url={file.url}
              filename={file.filename}
              deleteFile={deleteFile}
            />
          ))}
      </div>
    </div>
  ),
  css
);

FileUploadView.propTypes = {
  allowDownload: PropTypes.bool,
  column: PropTypes.object,
  deleteFile: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  files: PropTypes.array,
  placeholder: PropTypes.string,
  showFilepicker: PropTypes.func.isRequired,
  loadingUpload: PropTypes.bool
};

export default props => (
  <FileFactory {...props}>
    <FileUploadView />
  </FileFactory>
);
